/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of competition
 * @export
 */
export const CompetitionType = {
    TOURNAMENT: 'TOURNAMENT',
    LEAGUE: 'LEAGUE',
    LEADERBOARD: 'LEADERBOARD',
    GUILD: 'GUILD',
    LADDER: 'LADDER',
    CHALLENGE: 'CHALLENGE',
    CIRCUIT: 'CIRCUIT'
} as const;
export type CompetitionType = typeof CompetitionType[keyof typeof CompetitionType];


export function instanceOfCompetitionType(value: any): boolean {
    for (const key in CompetitionType) {
        if (Object.prototype.hasOwnProperty.call(CompetitionType, key)) {
            if (CompetitionType[key as keyof typeof CompetitionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionTypeFromJSON(json: any): CompetitionType {
    return CompetitionTypeFromJSONTyped(json, false);
}

export function CompetitionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionType {
    return json as CompetitionType;
}

export function CompetitionTypeToJSON(value?: CompetitionType | null): any {
    return value as any;
}

export function CompetitionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionType {
    return value as CompetitionType;
}

